import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoNotificationService, PoSearchFilterMode, PoTableColumn } from '@po-ui/ng-components';
import { RomaneioService } from 'src/app/estoque/romaneio/service/romaneio.service';
import { ZprLookupService } from 'src/app/service/zpr-lookup.service';
import { ControleQualidadeCadastroItem, ControleQualidadeCadastroLista, getControleQualidadeCadastroListaDefault } from '../../interface/controle-qualidade';
import { Zpr } from 'src/app/interface/zpr';
import { FiltroControleQualidadeLista } from '../../filter/filtro-controle-qualidade-lista';
import { PoStorageService } from '@po-ui/ng-storage';

@Component({
  selector: 'app-controle-qualidade-cadastro',
  templateUrl: './controle-qualidade-cadastro.component.html',
  styleUrls: ['./controle-qualidade-cadastro.component.css']
})
export class ControleQualidadeCadastroComponent implements OnInit {

  etiqueta: string = '';
  controleQualidade: ControleQualidadeCadastroLista;
  bipadasHoje: Array<any>;

  zprAdvancedFilters: Array<PoDynamicFormField>;
  zprColumnsFilters: Array<PoLookupColumn>;
  zprFieldFormaterFilters: (value: Zpr) => string;

  filtroLista: FiltroControleQualidadeLista;
  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  constructor(
    private romaneioService: RomaneioService,
    private router: Router,
    private poNotificationService: PoNotificationService,
    private poStorageService: PoStorageService,
    public zprService: ZprLookupService,
  ) {
    this.controleQualidade = getControleQualidadeCadastroListaDefault();

    this.zprService.grupo        = 'MOTQUALID';
    this.zprAdvancedFilters      = this.zprService.getAdvancedFilter();
    this.zprColumnsFilters       = this.zprService.getColumnsFilterCompleto();
    this.zprFieldFormaterFilters = this.zprService.getFieldFormater;

    this.filtroLista = new FiltroControleQualidadeLista(this.poStorageService);

    this.bipadasHoje = [];
  }

  @ViewChild('reprovarModal', { static: true }) reprovarModal!: PoModalComponent;

  ngOnInit(): void {
    this.filtroLista.dados = this.filtroLista.setDefault();
    this.filtroLista.dados.CAPENASUSUARIO = 'S';
    this.romaneioService.getControleQualidadeLista(this.filtroLista.dados).subscribe((ret) => {
      this.bipadasHoje = ret.items;
    })
  }

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Controle Qualidade', action: this.goTo.bind(this) },
      { label: 'Lista', action: this.goToLista.bind(this) },
      { label: 'Novo Cadastro' }
    ]
  };

  goTo(): void {
    this.router.navigateByUrl('');
  }

  goToLista(): void {
    this.router.navigateByUrl('/estoque/romaneio/controle-qualidade/lista');
  }

  public readonly colunas: Array<PoTableColumn> = [
    { property: 'CZ04LOTE', visible: true, label: 'Etiqueta' },
    { property: 'CB1COD', visible: false, label: 'Produto' },
    { property: 'CB1DESC', visible: true, label: 'Descrição' },
    { property: 'NQTD', visible: true, label: 'Quantidade' },
    {
      property: 'favorite',
      label: '...',
      type: 'icon',
      width: '10%',
      icons: [
        {
          action: this.excluirItem.bind(this),
          icon: 'po-icon-delete',
          tooltip: 'Excluir Item',
          value: 'delete',
        },
      ]
    },
  ];

  public readonly colunasBipadas: Array<PoTableColumn> = [
    {property: 'CZ04CODIGO' , label: 'Código'           , width: '10%'},
    {property: 'CZ04LOTE'   , label: 'Lote'             , width: '10%'},
    {property: 'DZ04DATA'   , label: 'Data'             , width: '10%', type: 'date', format: 'dd/MM/yyyy'},
    {property: 'CZ04HORA'   , label: 'Hora'            , width: '10%'},
    {property: 'CZ04TURNO'  , label: 'Turno'            , width: '10%'},
    {property: 'CZ04STATUS' , label: 'Status'           , width: '10%', type: 'label',
      labels: [
        { value: 'A', color: 'color-01',  label: 'Aprovado'    },
        { value: 'R', color: 'color-05',  label: 'Recusado' },
      ]
    },
    {property: 'CZPRGENERI' , label: 'Motivo'         , width: '30%'},
  ];

  excluirItem(row: ControleQualidadeCadastroItem): void {
    this.controleQualidade.items = this.controleQualidade.items.filter((item) => {
      return item.CZ04LOTE != row.CZ04LOTE;
    });
  }

  biparEtiqueta(): void {
    if (this.etiqueta != '') {
      let etiq = this.etiqueta;
      if (etiq.length > 7 && etiq.substring(0,3) == "000") {
        etiq = etiq.substring(3,etiq.length);
      }

      let lContinua = true;
      this.controleQualidade.items.map((itemControle) => {
        if (itemControle.CZ04LOTE == etiq) {
          lContinua = false;
        }
      });

      if (lContinua) {
        this.romaneioService.getDadosEtiquetaControleQualidade(etiq).subscribe((ret) => {
          if (ret.CZ04STATUS != "A") {
            this.controleQualidade.items.push({...ret, CZ04LOTE: etiq, favorite: ['delete']});
            if (ret.CZ04STATUS == "R") {
              this.poNotificationService.warning("Aviso: Esta etiqueta já foi rejeitada uma vez e agora só poderá ser aprovada!")
            }
          } else {
            this.poNotificationService.error("Esta etiqueta já foi aprovada anteriormente!")
          }
        });
      } else {
        this.poNotificationService.error("Esta etiqueta já consta neste Controle de Qualidade!")
      }
      this.etiqueta = '';
    }
  }

  modalReprovarOpen(): void {
    this.reprovarModal.open();
  }

  aprovarEtiquetas(): void {
    this.controleQualidade.motivo='';
    this.controleQualidade.status='A';
      this.romaneioService.postControleQualidade(this.controleQualidade).subscribe((ret) => {
        this.poNotificationService.success("Etiqueta(s) aprovada(s) com sucesso!");
        this.goToLista();
      });
  }

  public readonly reprovarAction: PoModalAction = {
    action: () => {
      if (this.controleQualidade.motivo != '') {
        this.reprovarModal.close();
        this.controleQualidade.status='R';
        this.romaneioService.postControleQualidade(this.controleQualidade).subscribe((ret) => {
          this.poNotificationService.success("Etiqueta(s) reprovada(s) com sucesso!");
          this.goToLista();
        });
      } else {
        this.poNotificationService.error("Por favor, preencha o motivo da rejeição!");
      }
    },
    label: 'Reprovar'
  };

}
